import React from 'react';
import PropTypes from 'prop-types';
import styles from './CityPairLabel.module.scss';

const CityPairLabel = ({origin, destination, ...props}) => {

    return (
        <div className={styles.container} {...props}>
            <div className={styles.labelsContainer}>
                <div className={styles.originLabel}>{origin}</div>
                <div className={styles.destinationLabel}>{destination}</div>
            </div>
            <div className={styles.pointsContainer}>
                <div className={styles.originPoint}/>
                <div className={styles.destinationPoint}/>
            </div>
        </div>
    );
};

CityPairLabel.propTypes = {
    origin: PropTypes.string,
    destination: PropTypes.string,
};

CityPairLabel.defaultProps = {
    origin: PropTypes.string,
    destination: PropTypes.string,
};

export default CityPairLabel;